const RELATIONSHIPS = [
	"SPOUSE",
	"CHILD",
	// "SON",
	// "DAUGHTER",
	"STEP CHILD",
	"COURT-ORDERED DEPENDENT",
	"LEGAL CUSTODY CHILD",
	"GRANDCHILD",
	"OTHERS"
];

export default RELATIONSHIPS;
